import { Features } from 'src/app/state/types/loc-profile';
import { useFeatureCheck } from 'src/app/state/user-dispensaries';

import {
  applicationMethodsWithThresholdsWithLoyalty,
  ApplicationMethodTypeId,
  appMethodsWithThresholds,
  calculationMethodOptions,
  calculationMethodOptionsWithLoyaltyMultipliers,
  manualDiscountCalculationOptions,
} from '../../../models';
import { useDiscountWizardStateContext } from '../../state';

export function useDiscountMethods(useLoyaltyBoosters: boolean) {
  const includeLoyaltyMethods = useFeatureCheck(Features.LoyaltyAsCartDiscount);

  const {
    configureStepState: { applicationMethod },
  } = useDiscountWizardStateContext();

  if (
    (includeLoyaltyMethods && applicationMethodsWithThresholdsWithLoyalty.includes(applicationMethod)) ||
    appMethodsWithThresholds.includes(applicationMethod) ||
    applicationMethod === ApplicationMethodTypeId.DutchieLoyalty
  ) {
    if (useLoyaltyBoosters && applicationMethod === ApplicationMethodTypeId.Automatically) {
      return calculationMethodOptionsWithLoyaltyMultipliers;
    }
    return calculationMethodOptions;
  }

  return manualDiscountCalculationOptions;
}
